<template>
<div class="chapter">
<div class="inner_page">
<div id="dabef9d1bfb79-d1e356"><span id="pagevii">
<h2 class="acknowledgements-head">ACKNOWLEDGEMENTS</h2>
<p class="acknowledgements-text">Mr Nick Sayers at Hodder &amp; Stoughton. His belief in me and the manuscripts kept me going.</p>
<p class="acknowledgements-text-indented">Kate Lyall-Grant and all at Severn House Publishers.</p>
<p class="acknowledgements-text-indented">Mr David Grossman, my literary agent.</p>
<p class="acknowledgements-text-indented">David Meykell, clerk of the course, Leicester Racecourse, for allowing me to ‘do’ a murder on his racecourse.</p>
<p class="acknowledgements-text-indented">Roderick Duncan, clerk of the course, Southwell Racecourse.</p>
<p class="acknowledgements-text-indented">Jean Hedley, clerk of the course, Nottingham Racecourse.</p>
<p class="acknowledgements-text-indented">Mark McGrath, former manager, Best Western North Shore Hotel and Golf Course, Skegness.</p>
<p class="acknowledgements-text-indented">Bill Hutchinson, present manager, and all the lovely staff at the above hotel with special thanks to Gavin Disney, Dan, Nikki and Katie for all their help.</p>
<p class="acknowledgements-text-indented">Sarah at Sarah’s Flowershop.</p>
<p class="acknowledgements-text-indented">All the library staff at Bingham, Radcliffe-on-Trent and Nottingham Central, with special thanks to Steve and to Rosie for her expertise on computers.</p>
<p class="acknowledgements-text-indented">David and Anne Brown, printers and friends for bailing me out – twice – and finding just where chapters twelve and thirteen had disappeared to!</p>
<p class="acknowledgements-text-indented">Lois from Crime Readers Group, a savvy lady who gave me confidence at the start.</p>
<p class="acknowledgements-text-indented">The police at Skegness and the staff at Nottingham Prison for checking facts.</p>
<p class="acknowledgements-text-indented">Management at The Dirty Duck at Woolsthorpe.</p>
<p class="acknowledgements-text-indented">Kirsty at The Unicorn Hotel at Gunthorpe.</p>
<p class="acknowledgements-text-indented">Vickie Litchfield at The Royal Oak, Radcliffe-on-Trent.</p>
<p class="acknowledgements-text-indented">And for all the people who have helped me in whatever way during the course of writing the ‘Harry’ novels, may I say a very big thank you and have a great read.</p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780106403_epub_ack.vue?2956635f